import './walkscore.css';
import { IListing } from "../../../models/listing.model";
import { IBranding } from '../../../models/branding.model';
import { isNullOrUndefinedOrBlank } from '../../../util/isNullOrUndefinedOrBlank';
import { useEffect, useRef } from 'react';

export interface WalkscoreProps {
  listing: IListing;
  branding: IBranding;
}

export const Walkscore = (props: WalkscoreProps) => {

  const divRef = useRef<HTMLInputElement>(null);
  const isFirstRender = useRef(true)
  const ws_wsid = props.branding.walkscore_api_key;
  const ws_address = props.listing.address + ', ' + props.listing.city + ', ' + props.listing.state;
  const html = ("<script type='text/javascript'>\n var ws_div_id='ws-walkscore-listing-tile'\nvar ws_wsid = '" + ws_wsid + "';\nvar ws_address = '" + ws_address + "';\nvar ws_format = 'square';\nvar ws_width = '100%';\nvar ws_height = '500';\n</script><div id='ws-walkscore-listing-tile'></div><script type='text/javascript' src='https://www.walkscore.com/tile/show-walkscore-tile.php'></script>");

  useEffect(() => {
    if (isNullOrUndefinedOrBlank(props.branding.walkscore_api_key)) return
    if (!html || !divRef.current) return
    if (!isFirstRender.current) return
    isFirstRender.current = false

    const slotHtml = document.createRange().createContextualFragment(html) // Create a 'tiny' document and parse the html string
    divRef.current.innerHTML = '' // Clear the container
    divRef.current.appendChild(slotHtml) // Append the new content
  }, [html, divRef, props.branding.walkscore_api_key])

  return <div ref={divRef} />
}



